// extracted by mini-css-extract-plugin
export default {"root":"TreePromo__root--diubo","link":"TreePromo__link--X0dlq","text":"TreePromo__text--2FlP_","close":"TreePromo__close--22yFQ"};